// extracted by mini-css-extract-plugin
export default {"container__atualizarproduto":"AtualizarProduto_container__atualizarproduto__g6BuL","back__btn":"AtualizarProduto_back__btn__tbA2c"};